import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Flame, ChevronLeft, ShoppingCart } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

const MerchHeader = () => {
  const navigate = useNavigate();
  const { count } = useCart();

  return (
    <header className="bg-[#0a1030] text-white sticky top-0 z-30">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 md:px-12 py-5">
        <Link to="/" className="flex items-center gap-2">
          <Flame className="h-6 w-6" strokeWidth={2.5} />
          <span className="font-extrabold tracking-wide text-[14px] md:text-[15px]">
            APOSTOLIC CHRIST TABERNACLE
          </span>
        </Link>
        <div className="flex items-center gap-5">
          <button
            onClick={() => navigate('/')}
            className="hidden sm:flex items-center gap-1 text-sm text-white/80 hover:text-white transition-colors"
          >
            <ChevronLeft className="h-4 w-4" /> Home
          </button>
          <Link
            to="/merch/cart"
            className="relative flex items-center gap-2 rounded-full bg-white/10 hover:bg-white/20 border border-white/20 px-4 py-2 text-sm transition-colors"
          >
            <ShoppingCart className="h-4 w-4" />
            <span>Cart</span>
            {count > 0 && (
              <span className="ml-1 bg-[#e9d9a0] text-[#0a1030] text-[10px] font-bold rounded-full px-2 py-0.5 min-w-[22px] text-center">
                {count}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default MerchHeader;
